import { render, staticRenderFns } from "./MarketingNav.vue?vue&type=template&id=3bff6511&scoped=true&"
import script from "./MarketingNav.vue?vue&type=script&lang=js&"
export * from "./MarketingNav.vue?vue&type=script&lang=js&"
import style0 from "./MarketingNav.vue?vue&type=style&index=0&id=3bff6511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff6511",
  null
  
)

export default component.exports